// extracted by mini-css-extract-plugin
module.exports = {"congrats":"Congrats__congrats___XutWS"};